import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type CreateProvingMutationVariables = {
  input: Types.ProvingInsertType
};


export type CreateProvingMutation = (
  { __typename?: 'Mutation' }
  & { createProving: (
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'type' | 'id' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'created'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id'>
    )> }
  ) }
);

export type ReadProvingsMyBookingsViewQueryVariables = {};


export type ReadProvingsMyBookingsViewQuery = (
  { __typename?: 'Query' }
  & { myBookings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title'>
    & { participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'nordschleife' | 'nordschleifeBookingStatus' | 'dateTo' | 'dateFrom'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'department' | 'upn' | 'external' | 'roles' | 'companyName' | 'userType' | 'extension' | '_id' | 'name' | 'email' | 'employeeId' | 'type'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id' | 'name' | 'email' | 'employeeId' | 'type'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus'>
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title'>
        )> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'dateTo' | 'dateFrom' | 'carType' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateTo' | 'timeTo' | 'dateFrom' | 'timeFrom' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>> }
      )> }
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )> }
  )>, principal: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'type' | 'upn' | 'name' | 'email' | 'roles' | 'companyName' | 'userType' | 'employeeId'>
  )> }
);

export const CreateProvingDocument = gql`
    mutation CreateProving($input: ProvingInsertType!) {
  createProving(input: $input) {
    _id
    type
    id
    status
    title
    description
    dateTo
    dateFrom
    created
    responsible {
      _id
    }
  }
}
    `;
export type CreateProvingMutationFn = ApolloReactCommon.MutationFunction<CreateProvingMutation, CreateProvingMutationVariables>;

    export function useCreateProvingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProvingMutation, CreateProvingMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateProvingMutation, CreateProvingMutationVariables>(CreateProvingDocument, baseOptions);
    };
export type CreateProvingMutationHookResult = ReturnType<typeof useCreateProvingMutation>;
export type CreateProvingMutationResult = ApolloReactCommon.MutationResult<CreateProvingMutation>;
export type CreateProvingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProvingMutation, CreateProvingMutationVariables>;
export const ReadProvingsMyBookingsViewDocument = gql`
    query ReadProvingsMyBookingsView {
  myBookings {
    _deleted
    id
    _id
    status
    title
    participants {
      _id
      nordschleife
      nordschleifeBookingStatus
      dateTo
      dateFrom
      person {
        _id
        name
        email
        employeeId
        type
        ... on User {
          department
          upn
          external
          roles
          companyName
          userType
          extension
        }
      }
      flight {
        flightType
        bookingStatus
      }
      accomodation {
        accomodationType
        accomodation {
          _id
          title
        }
        dateFrom
        dateTo
        bookingStatus
      }
      rentalCar {
        dateTo
        dateFrom
        carType
        bookingStatus
      }
      ferry {
        outward {
          _id
          title
          type
          origin
          destination
        }
        return {
          _id
          title
          type
          origin
          destination
        }
        dateTo
        timeTo
        dateFrom
        timeFrom
        bookingStatus
      }
      trackHotels {
        outward {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
        return {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
      }
    }
    provingGround {
      _id
      title
      countryCode
    }
  }
  principal {
    _id
    type
    upn
    name
    email
    roles
    companyName
    userType
    employeeId
  }
}
    `;

    export function useReadProvingsMyBookingsViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsMyBookingsViewQuery, ReadProvingsMyBookingsViewQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsMyBookingsViewQuery, ReadProvingsMyBookingsViewQueryVariables>(ReadProvingsMyBookingsViewDocument, baseOptions);
    };
      export function useReadProvingsMyBookingsViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsMyBookingsViewQuery, ReadProvingsMyBookingsViewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsMyBookingsViewQuery, ReadProvingsMyBookingsViewQueryVariables>(ReadProvingsMyBookingsViewDocument, baseOptions);
      };
      
export type ReadProvingsMyBookingsViewQueryHookResult = ReturnType<typeof useReadProvingsMyBookingsViewQuery>;
export type ReadProvingsMyBookingsViewQueryResult = ApolloReactCommon.QueryResult<ReadProvingsMyBookingsViewQuery, ReadProvingsMyBookingsViewQueryVariables>;